"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationSecondStep = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _react = require("react");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GeneralButton = require("../../atoms/GeneralButton");

var _LoginPasswordStrength = require("../../molecules/LoginPasswordStrength");

var _LogoImage = require("../../atoms/LogoImage");

var _jsxRuntime = require("react/jsx-runtime");

var RegistrationSecondStep = function RegistrationSecondStep(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      privacyCheck = _useState2[0],
      setPrivacyCheck = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      termsCheck = _useState4[0],
      setTermsCheck = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emptyPassword = _useState6[0],
      setEmptyPassword = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      emptyConfirmPassword = _useState8[0],
      setEmptyConfirmPassword = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      matchPasswords = _useState10[0],
      setMatchPasswords = _useState10[1];

  var nuevoUsuario = JSON.parse(sessionStorage.getItem("nuevoRegistro"));

  var validateForm = function validateForm(evt, valid) {
    evt.preventDefault();
    var password = document.querySelector("#newPasswordInput").value;
    !termsCheck && (valid = false);
    !privacyCheck && (valid = false);

    if (valid) {
      nuevoUsuario.password = password;
      sessionStorage.setItem("nuevoRegistro", JSON.stringify(nuevoUsuario));
      valid && props.setPaso(3);
    }
  };

  var validate = function validate(e) {
    e.preventDefault();
    var valid = true;
    var password = document.querySelector("#newPasswordInput").value;
    password.length < 8 ? setEmptyPassword(true) : setEmptyPassword(false);
    var confirmPassword = document.querySelector("#confirmPasswordInput").value;
    confirmPassword === "" ? setEmptyConfirmPassword(true) : setEmptyConfirmPassword(false);
    password === confirmPassword ? setMatchPasswords(true) : setMatchPasswords(false);

    if (password.length < 8 || confirmPassword === "" || password !== confirmPassword) {
      valid = false;
    }

    return valid;
  };

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginPasswordStrength.LoginPasswordStrength, {
    emptyPassword: emptyPassword,
    emptyConfirmPassword: emptyConfirmPassword,
    matchPasswords: matchPasswords,
    textTittle: "Ingresa tus credenciales",
    required: "required"
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
    className: "label-terms",
    children: "T\xE9rminos y condiciones"
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "checkbox-terms",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      onClick: function onClick(e) {
        return setTermsCheck(e.target.checked);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Conoce nuestros termnios y condiciones de cada uno de nuestros servicios. Si tienes algunda duda o comentario escríbenos.",
      headerType: "date-header"
    })]
  }, "5"), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
    className: "label-terms",
    children: "Aviso de privacidad"
  }, "6"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "checkbox-terms",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      onClick: function onClick(e) {
        return setPrivacyCheck(e.target.checked);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Todos los datos estan protegidos.",
      headerType: "date-header"
    })]
  }, "7"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "button-end",
    children: [(!termsCheck || !privacyCheck) && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      className: "terms",
      children: "*Aceptar los t\xE9rminos y condiciones y el aviso de privacidad"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        var flag = validate(e);
        validateForm(e, flag);
      }
    })]
  }, "8"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "progress-bar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-first-step-check"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-second-step"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-registration"
    })]
  }, "9"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
    text: "Paso 2",
    headerType: "date-header",
    color: _variables.GlobalColors.s4
  }, "10"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "new-login",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "pre-registro",
      children: ["\xBFA\xFAn no tienes cuenta?", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: " Reg\xEDstrate"
      })]
    })
  }, "11")];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
      panelColor: _variables.GlobalColors.white,
      componentsArray: loginRight,
      panelType: "home-login"
    })
  });
};

exports.RegistrationSecondStep = RegistrationSecondStep;